import { evolutionLevels, getChainId, getChainName, getOpenSeaApiUrl, OpenSeaApiKey } from 'components/Constants';
import queryString from 'query-string';

export const normalizeBaton = (data, id) => {
  // Handle v2 API structure
  const tokenData = data.token || data;
  const metadata = data.metadata || data;
  
  const normalized = {
    ...data,
    id: data.identifier || tokenData.token_id || id,
    members: [],
  };

  // v2 API attributes are in metadata.attributes
  const attributes = metadata.attributes || data.attributes || data.traits;

  if (Array.isArray(attributes)) {
    attributes.forEach(attr => {
      let name = attr.trait_type;
      const value = attr.value;
      if (!name || name === 'property') {
        normalized.members.push(value);
      }
      else {
        const key = name.replace(/[^a-z0-9]/ig, '_').toLowerCase();
        normalized[key] = value;
      }
    });
  }
  
  normalized.evolution = (normalized.evolution || 'common').toLowerCase();
  normalized.evolution_level = evolutionLevels.indexOf(normalized.evolution);
  normalized.is_normalized = true;
  
  // Handle v2 API field mappings
  normalized.token_id = normalized.id; // alias
  // v2 API uses display_image_url for cached CDN images
  normalized.image = data.display_image_url || metadata.image_url || normalized.image || normalized.image_url; // alias
  normalized.name = metadata.name || normalized.name;
  normalized.description = metadata.description || normalized.description;
  
  // Map v2 contract structure
  if (data.contract) {
    normalized.asset_contract = {
      address: data.contract.address || tokenData.address,
      name: data.contract.name,
      symbol: data.contract.symbol || tokenData.symbol
    };
  }
  
  return normalized;
}

export const shortenString = (string, max) => {
  return string.substring(0, (max / 2) - 1) + '...' + string.substring(string.length - (max / 2) + 2, string.length)
}

export const getIpfsGatewayUrl = (ipfsUrl) => {
  return (ipfsUrl || '').replace('ipfs://', 'https://passthebaton.mypinata.cloud/ipfs/');
}

export const fetchOpensea = async (path, options = {}) => {
  var chainId = options.chainId || getChainId();
  var chainName = getChainName(chainId);
  var baseUrl = getOpenSeaApiUrl(chainId);
  var { params } = options;

  // Handle v2 API chain-specific endpoints
  var url;
  if (path.startsWith('/chain/')) {
    // Already a v2 chain-specific path
    url = baseUrl + path;
  } else if (path === '/assets' && options.owner) {
    // Convert v1 assets endpoint to v2 account NFTs endpoint
    url = `${baseUrl}/chain/${chainName}/account/${options.owner}/nfts`;
    // Remove owner from params since it's now in the path
    params = { ...params };
    delete params.owner;
  } else {
    // Other endpoints - use as-is
    url = baseUrl + path;
  }

  const headers = {};
  if (chainId === 1) {
    headers['X-API-KEY'] = OpenSeaApiKey;
  }

  if (params && Object.keys(params).length > 0) {
    url += `?${queryString.stringify(params)}`
  }

  const resp = await fetch(url, {
    headers: headers
  })
  return await resp.json()
}